/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { css } from "@emotion/react";
import { Trans } from "react-i18next";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { textColor } from "main/javascripts/styles/base/colorStyle";
import { fontSize } from "main/javascripts/styles/base/typographyStyle";

export interface IProps {
  imageUrl?: string;
  vesselBrandName: string;
}

export const CruiseCertifiedMark: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { imageUrl, vesselBrandName } = props;

  if (!imageUrl) {
    return null;
  }

  return (
    <div css={blockStyle}>
      <div css={imageBlockStyle}>
        <img src={imageUrl} css={imageStyle} />
      </div>
      <div>
        <Trans
          i18nKey="component:cruise.certifiedMarkDescription"
          values={{ brandName: vesselBrandName }}
        >
          TabiChat is a certified travel agency
          <br /> by {{ vesselBrandName }}.
        </Trans>
      </div>
    </div>
  );
};

const blockStyle = css`
  display: grid;
  grid-template-columns: 3.5rem auto;
  gap: ${space.atom8x};
  align-items: center;
  font-size: ${fontSize.mediumHeading};
  line-height: 1.4;
  color: ${textColor.secondaryDarkColor};
  word-break: keep-all;
  overflow-wrap: anywhere;
`;
const imageBlockStyle = css`
  duisplay: flex;
`;
const imageStyle = css`
  display: block;
  width: 200%;
  height: auto;
`;
